import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-bookseller-view-print-order-component',
  templateUrl: './bookseller-view-print-order-component.component.html',
  styleUrls: ['./bookseller-view-print-order-component.component.scss']
})
export class BooksellerViewPrintOrderComponentComponent implements OnInit {

  id!: number;

  book_name = '';
  adesh_date: any = '';
  publish_date: any = '';

  totalprati = 0;
  totalpsankhya = 0;

  tempdata: any[] = [];

  constructor(
    private service: DigisubservicesService,
    private dialogRef: MatDialogRef<BooksellerViewPrintOrderComponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    console.log('Dialog Data =>', this.data); // ✅ debug

    this.id = this.data?.id;

    if (this.id) {
      this.loadOrder();
    } else {
      console.warn('ID not found in dialog data');
    }
  }

  loadOrder(): void {
    this.service.getPrintOrderById(this.id).subscribe(
      (res: any) => {
        console.log('API Response =>', res);

        if (res?.success) {

          const header = res.data || {};

          this.book_name     = header.book_name || '';
          this.adesh_date    = header.adesh_date || '';
          this.publish_date  = header.publish_date || '';
          this.totalpsankhya = header.ekun_prushth || 0;

          this.tempdata = (res.items || []).map((item: any, index: number) => ({
            no: index + 1,
            name: item.name,
            prati: Number(item.copies || 0),
            shera: item.remarks || ''
          }));

          this.calculateTotal();
        }
      },
      (error) => {
        console.error('API Error =>', error);
      }
    );
  }

  calculateTotal(): void {
    this.totalprati = this.tempdata.reduce(
      (sum, item) => sum + Number(item.prati || 0),
      0
    );
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}